import { render, staticRenderFns } from "./EventDetailContainer.vue?vue&type=template&id=5e3f1d82&"
import script from "./EventDetailContainer.vue?vue&type=script&lang=js&"
export * from "./EventDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports